import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import { Card } from "@/app/admin/_common/ui/card";

export default function FestivalDetailSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-2 gap-2.5 lg:grid-cols-5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Card key={i} className="rounded-md p-3.5 shadow-none">
            <Skeleton className="mb-2 h-3 w-20" />
            <Skeleton className="mb-2 h-5 w-16" />
            <Skeleton className="h-3 w-12" />
          </Card>
        ))}
      </div>

      <div className="flex min-h-0 flex-1 flex-col gap-3 md:flex-row">
        <div className="min-w-0 rounded-md border border-border bg-card p-3 md:basis-[60%]">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 border-b border-border/50 py-2.5 last:border-0">
              <Skeleton className="size-8 flex-none rounded" />
              <Skeleton className="h-3 flex-1" />
              <Skeleton className="h-3 w-16" />
              <Skeleton className="h-3 w-16" />
            </div>
          ))}
        </div>
        <div className="flex min-w-0 flex-col gap-3 md:basis-[40%]">
          <Card className="rounded-md p-4 shadow-none">
            <Skeleton className="mb-3 h-4 w-16" />
            <Skeleton className="mb-2 h-2 w-full" />
            <Skeleton className="h-24 w-full" />
          </Card>
        </div>
      </div>

      <div className="rounded-md border border-border bg-card p-3">
        <Skeleton className="mb-3 h-4 w-24" />
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 border-b border-border/50 py-2.5 last:border-0">
            <Skeleton className="h-3 flex-1" />
            <Skeleton className="h-3 w-24" />
          </div>
        ))}
      </div>
    </div>
  );
}
